@if (bookmarkCategoryStore.asArray(); as bookmarkCategories) {
  @if (bookmarkCategories.length > 0) {
    <p-pickList
      #listPickerCtrl
      [source]="bookmarkCategories"
      [target]="selected"
      sourceHeader="Themenbereiche"
      targetHeader="Auswahl"
      [dragdrop]="true"
      [responsive]="true"
      [showSourceControls]="showSourceControls"
      [showTargetControls]="showTargetControls"
      (onMoveToSource)="updateSelection()"
      (onMoveToTarget)="updateSelection()"
      (onMoveAllToSource)="updateSelection()"
      (onMoveAllToTarget)="updateSelection()"
      [sourceStyle]="{ height: '30rem' }"
      [targetStyle]="{ height: '30rem' }"
      breakpoint="1400px">
      <ng-template let-bookmarkCategory pTemplate="item">
        <div class="flex-1 flex flex-column gap-2">
          <div class="flex align-items-center gap-2 text-lg">
            <i class="fas fa-layer-group"></i>
            <span>
              {{ bookmarkCategory.title }}
            </span>
          </div>
        </div>
      </ng-template>
    </p-pickList>
  } @else {
    <app-alert styleClass="m-0 p-3" [canToggle]="false" severity="secondary">
      Keine Themenbereiche gefunden
    </app-alert>
  }
}
